import Vue from 'vue'
import Router from 'vue-router'
import {getQueryStringByName, setStoreInfo} from '@/utils/commonUtil'

// // 注：官方vue-router@3.0及以上新版本路由默认回调返回的都是promise，原先旧版本的路由回调将废弃！！！！
// // vue-router@3.0版本及以上回调形式已经改成promise api的形式了，返回的是一个promise，如果路由地址跳转相同, 且没有捕获到错误，控制台始终会出现如图所示的警告 （注：3.0以下版本则不会出现以下警告！！！，因路由回调问题…）
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)
let path = goPage()
let requireAll = requireContext => requireContext.keys().map(requireContext)
let req = require.context('./', false, /^(\.\/(?!index|util)).*\.js$/)
let routes = requireAll(req).reduce((accumulator, currentValue, currentIndex, array) => {
  return [...accumulator, ...currentValue.default]
}, [])

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

// index文件不需要修改，在router文件夹添加模块(文件)，格式参照demo.js
export default new Router({
  routes: [
    ...routes,
    {path: '/', redirect: path},
    // {path: '/', redirect: '/todoCenter/quote/ApproveDetail'},
    // {path: '*', redirect: '/login'},
    // {path: '*', redirect: '/entry'},
    // {path: '*', redirect: '/account/list'},
    // {path: '*', redirect: '/salesorder/list'},
    // {path: '*', redirect: '/opportunity/list'},
    // {path: '*', redirect: '/calendar/list'},
    // {path: '*', redirect: '/approval/list'},
    // {path: '*', redirect: '/multpositioning'},
  ],
})

// 路由跳转
function goPage () {
  const routeName = getQueryStringByName('routeName')
  const businessType = getQueryStringByName('businessType') || ''
  setStoreInfo('Opportunity', 'businessType', businessType)
  // const id = getQueryStringByName('id') || ''
  const entityid = getQueryStringByName('entityid') || ''
  const entityname = getQueryStringByName('entityname') || ''
  const taskid = getQueryStringByName('taskid') || ''
  const taskItem = {
    id: taskid,
    hd_entityname: entityname,
    hd_record_id: entityid,
  }
  switch (routeName) {
    case 'MtReportOpportunity_detail': // 商机报备
      setStoreInfo('ReportOpportunity', 'opportunityId', entityid)
      setStoreInfo('OppContact', 'oppId', entityid)
      setStoreInfo('TodoCenter', 'taskItem', taskItem)
      return '/mtReportOpportunity/list/detail'
    case 'Opportunity_detail': // 商机
      setStoreInfo('Opportunity', 'opportunityId', entityid)
      setStoreInfo('OppContact', 'oppId', entityid)
      setStoreInfo('TodoCenter', 'taskItem', taskItem)
      return '/opportunity/list/detail'
    case 'PaymentMgmt_detail': // 收款管理
      setStoreInfo('PaymentMgmt', 'paymentMgmtId', entityid)
      return '/paymentMgmt/list/detail'
    case 'WbVisitPlan_detail': // 拜访计划
      setStoreInfo('WbVisitPlan', 'wbVisitPlanId', entityid)
      return '/wbVisitPlan/list/detail'
    case 'Quote_detail': // 待办列表
      setStoreInfo('TodoCenter', 'taskItem', taskItem)
      setStoreInfo('TodoCenter', 'todoItemId', entityid)
      setStoreInfo('TodoCenter', 'businessType', businessType)
      return '/todoCenter/quote/detail'
    case 'Approve_detail': // TBJ
      console.log('taskItem---AAA-->', JSON.stringify(taskItem))
      setStoreInfo('TodoCenter', 'taskItem', taskItem)
      setStoreInfo('TodoCenter', 'todoItemId', entityid)
      return '/todoCenter/quote/ApproveDetail'
    case 'Feeinc_detail': // 增费
      setStoreInfo('TodoCenter', 'taskItem', taskItem)
      setStoreInfo('TodoCenter', 'todoItemId', entityid)
      return '/todoCenter/quote/FeeIncDetail'
    // case 'Contract_detail': // 合同进度汇总
    //   setStoreInfo('ApplyTodoList', 'taskid', taskid)
    //   return '/ContractApply/list/contract'
    case 'Entry':
      return '/entry'
    case 'BusinessOpportunity_detail': // 营业商机
      setStoreInfo('opportunity', 'opportunityId', entityid)
      return '/BusinessOpportunity/detail'
    default:
      return '/loginPage'
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js